export default __webpack_public_path__ + "static/media/character-akimoto.1ebf5ee7.png";